module.exports = __webpack_public_path__ + "static/img/design-6.66ef7bf9.png";